import { CashTransactionType } from '@/features/graphql/generated/graphql'
import { CashTransactionItem, PriceValue } from '@/features/shiftCloseouts/types'
import currencyJs from 'currency.js'
import invariant from 'tiny-invariant'

export interface CashTransactionTotals {
    deposits: PriceValue
    total: PriceValue
    withdrawals: PriceValue
}

export const calculateCashTransactionTotals = (
    currency: string,
    transactions: Pick<CashTransactionItem, 'amount' | 'type'>[]
): CashTransactionTotals => {
    let deposits = currencyJs(0)
    let withdrawals = currencyJs(0)

    transactions.forEach(({ amount, type }) => {
        invariant(amount.currency === currency, 'Currencies mismatch')

        if (type === CashTransactionType.Deposit) deposits = deposits.add(amount.amount)
        else withdrawals = withdrawals.add(amount.amount)
    })

    return {
        deposits: { amount: deposits.toString(), currency },
        total: { amount: deposits.subtract(withdrawals).toString(), currency },
        withdrawals: { amount: withdrawals.multiply(-1).toString(), currency },
    }
}
